/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyPoi
 */
export interface PropertyPoi {
    /**
     * 
     * @type {number}
     * @memberof PropertyPoi
     */
    poiId: number;
}

export function PropertyPoiFromJSON(json: any): PropertyPoi {
    return PropertyPoiFromJSONTyped(json, false);
}

export function PropertyPoiFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyPoi {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'poiId': json['poiId'],
    };
}

export function PropertyPoiToJSON(value?: PropertyPoi | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'poiId': value.poiId,
    };
}


